import CustomerAccount from './customer_account.vue';

export default CustomerAccount;
